"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toaster = exports.ToasterStyles = exports.ToastMaxWidth = exports.DefaultAutoDismissTimeMS = exports.HoverRestoreFadeTransitionTimeMS = exports.AutodimissCloseFadeTransitionTimeMS = exports.FadeTransitionTimeMS = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Localize_1 = require("../../../gen-src/Localize");
var DomUtil_1 = require("../../utils/DomUtil");
var PassiveAggressiveTimer_1 = require("../../utils/PassiveAggressiveTimer");
var ToastAnimator_1 = require("./ToastAnimator");
var ToastBase_1 = require("./ToastBase");
exports.FadeTransitionTimeMS = 300;
exports.AutodimissCloseFadeTransitionTimeMS = 1000;
exports.HoverRestoreFadeTransitionTimeMS = 30;
exports.DefaultAutoDismissTimeMS = 5000;
exports.ToastMaxWidth = 800;
exports.ToasterStyles = Object.freeze({
    centeringStyle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: exports.ToastMaxWidth
    },
    positioningDiv: {
        display: 'flex',
        justifyContent: 'center',
        left: 0,
        position: 'fixed',
        right: 0,
        top: 0,
        visibility: 'hidden', // TFS 843927 don't interfere with pointer events of headers underneath
    },
    toastDiv: {
        transitionProperty: 'transform, opacity',
    },
});
var DefaultToastProps = Object.freeze({
    autoDismiss: true,
    autoDismissTimeMS: exports.DefaultAutoDismissTimeMS,
});
function shouldAutoDismiss(props) {
    if (props.toastType === ToastBase_1.ToastType.Error || props.toastType === ToastBase_1.ToastType.Warning ||
        // eslint-disable-next-line deprecation/deprecation
        props.actionMessage || props.onAction) {
        return false;
    }
    return !!props.autoDismiss;
}
function extractBaseToastProps(props) {
    // eslint-disable-next-line deprecation/deprecation
    var autoDismiss = props.autoDismiss, autoDismissTimeMS = props.autoDismissTimeMS, topLeftXPx = props.topLeftXPx, topLeftYPx = props.topLeftYPx, zIndex = props.zIndex, baseToastProps = tslib_1.__rest(props, ["autoDismiss", "autoDismissTimeMS", "topLeftXPx", "topLeftYPx", "zIndex"]);
    return baseToastProps;
}
var Toaster = /** @class */ (function (_super) {
    tslib_1.__extends(Toaster, _super);
    function Toaster() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { focusWithin: false, pointerWithin: false, toasts: [] };
        return _this;
    }
    Toaster.prototype.componentDidUpdate = function (prevProps, prevState) {
        var currToasts = this.state.toasts;
        prevState.toasts.forEach(function (oldToast) {
            var _a, _b;
            // can't do a simple `filter` since we need to match on toast id rather than (cloned) toast object
            if (!currToasts.find(function (toast) { return toast.id === oldToast.id; })) {
                (_b = (_a = oldToast.props).onCloseRequest) === null || _b === void 0 ? void 0 : _b.call(_a);
            }
        });
    };
    Toaster.prototype.show = function (props) {
        var id = DomUtil_1.generateId();
        this.setState(function (_a) {
            var toasts = _a.toasts;
            return ({
                toasts: toasts.concat({
                    id: id,
                    props: tslib_1.__assign(tslib_1.__assign({}, DefaultToastProps), props)
                })
            });
        });
        return id;
    };
    Toaster.prototype.update = function (toastId, newProps) {
        this.setState(function (_a) {
            var toasts = _a.toasts;
            var toastIndex = toasts.findIndex(function (_a) {
                var id = _a.id;
                return id === toastId;
            });
            if (toastIndex < 0) {
                console.warn("found no toast matching id " + toastId);
                return null;
            }
            var toastsCopy = tslib_1.__spreadArray([], toasts);
            var mergedProps = tslib_1.__assign(tslib_1.__assign({}, toastsCopy[toastIndex].props), newProps);
            toastsCopy.splice(toastIndex, 1, { id: toastId, props: mergedProps });
            return { toasts: toastsCopy };
        });
    };
    Toaster.prototype.dismiss = function (toastId) {
        this.setState(function (_a) {
            var toasts = _a.toasts;
            var toastToRemove = toasts.find(function (_a) {
                var id = _a.id;
                return id === toastId;
            });
            if (!toastToRemove) {
                console.warn("found no toast matching id " + toastId);
                return null;
            }
            return { toasts: toasts.filter(function (t) { return t !== toastToRemove; }) };
        });
    };
    Toaster.prototype.getMaxZIndex = function () {
        var _a;
        var zIndexes = this.state.toasts.map(function (_a) {
            var props = _a.props;
            return props.zIndex;
        });
        zIndexes.push((_a = this.props.style) === null || _a === void 0 ? void 0 : _a.zIndex);
        zIndexes = zIndexes.filter(function (z) { return z !== undefined; });
        return zIndexes.length ? Math.max.apply(Math, zIndexes) : undefined;
    };
    Toaster.prototype.render = function () {
        var _this = this;
        var _a = this.state, focusWithin = _a.focusWithin, pointerWithin = _a.pointerWithin, toasts = _a.toasts;
        var toasterStyle = tslib_1.__assign(tslib_1.__assign({}, this.props.style), { zIndex: this.getMaxZIndex() });
        return (React.createElement("div", { "aria-label": Localize_1.Messages.alerts(), className: TypeStyle.style(exports.ToasterStyles.positioningDiv), onMouseEnter: function () { return _this.setState({ pointerWithin: true }); }, onMouseLeave: function () { return _this.setState({ pointerWithin: false }); }, onFocus: function () { return _this.setState({ focusWithin: true }); }, onBlur: function () { return _this.setState({ focusWithin: false }); }, role: 'region', style: toasterStyle },
            React.createElement(ToastAnimator_1.ToastAnimator, { style: exports.ToasterStyles.centeringStyle }, toasts.map(function (_a) {
                var id = _a.id, props = _a.props;
                var toastWidget = React.createElement(ToastBase_1.ToastBaseWidget, tslib_1.__assign({}, extractBaseToastProps(props), { id: id, key: id, onCloseRequest: function () { return _this.dismiss(id); } }));
                return React.createElement(PassiveAggressiveTimer_1.PassiveAggressiveTimer, { children: toastWidget, timerDuration: props.autoDismissTimeMS, handleTimerElapsed: function () { return _this.dismiss(id); }, key: id, pause: focusWithin || pointerWithin || !shouldAutoDismiss(props) });
            }).reverse())));
    };
    return Toaster;
}(React.PureComponent));
exports.Toaster = Toaster;
//# sourceMappingURL=Toaster.js.map